import { InfoCard, LinkButton } from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';
import { useReleasesAccess } from './useReleases';

/** En la ficha del servicio: enlace al rollback de la página Releases (solo devops y arquitectos lo ven). */
export const RollbackLink = () => {
  const { entity } = useEntity();
  const slug = entity.metadata.annotations?.['github.com/project-slug'] ?? '';
  if (!useReleasesAccess() || !slug.startsWith('deuna-platform/')) return null;
  return (
    <InfoCard title="Rollback">
      <LinkButton to={`/releases/rollback?slug=${encodeURIComponent(slug)}`} variant="outlined" color="secondary">
        Rollback en Releases
      </LinkButton>
    </InfoCard>
  );
};
